import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { Tab, type TabItem } from "@/shared/components"
import { getLastPath } from "@/shared/utils"

export type ICompanyAdministrationTab = "profile" | "users" | "energy-resource-accounting" | "energy-passport"

const tabs: Partial<Record<ICompanyAdministrationTab, TabItem>> = {
  profile: {
    label: "subscriber-card",
    path: "profile"
  },
  users: {
    label: "user-management",
    path: "users"
  }
  // "energy-resource-accounting": {
  //   label: "Учёт энергоресурсов",
  //   path: "energy-resource-accounting"
  // },
  // "energy-passport": {
  //   label: "Энергопаспорт",
  //   path: "energy-passport"
  // }
}

export const ConsumerAdministrationWrapper = () => {
  // Helpers
  const { pathname } = useLocation()
  const { t } = useTranslation()
  const navigate = useNavigate()

  // States
  const [activeTab, setActiveTab] = useState(tabs.profile as TabItem)

  const last = getLastPath(pathname) as ICompanyAdministrationTab
  const linkArr = pathname.replace(/\/+$/, "").split("/") as ICompanyAdministrationTab[]

  // Effects
  useEffect(() => {
    if (last in tabs) {
      setActiveTab(tabs[last])
    } else {
      linkArr.map(link => {
        if (link in tabs) {
          setActiveTab(tabs[link])
          return
        }
      })
    }
  }, [pathname])

  const onTabChange = (newTab: TabItem) => {
    setActiveTab(newTab)
    navigate(`/dashboard/administration/${newTab.path}`)
  }

  return (
    <>
      <div className="!h-16">
        <Tab
          spacing={0}
          size="sm"
          tabs={Object.values(tabs)}
          renderTab={tab => <div className="flex select-none items-center gap-2">{t(tab.label as any)}</div>}
          value={activeTab}
          onChange={onTabChange}
        />
      </div>
      <div className="-mt-3 flex h-full flex-col gap-4 overflow-hidden">
        <Outlet />
      </div>
    </>
  )
}
